
import Vue from 'vue'

// import ContextLink          from'./ContextLink.vue'
// import ContextLinkContainer from'./ContextLinkContainer.vue'
import ContextMenu2         from'./ContextMenu2.vue'

// Vue.component('ContextLink',          ContextLink)
// Vue.component('ContextLinkContainer', ContextLinkContainer)
Vue.component('ContextMenu2',         ContextMenu2)
